export default __webpack_public_path__ + "static/media/booch-newform.fcb0aabd.png";